module.exports = __webpack_public_path__ + "static/media/llama.241ce430.svg";